// TODO rename file to jsx file and move into components->globalComponents
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import IdleTimer from 'react-idle-timer';
// import PouchDB from 'pouchdb';
import { Link } from 'react-router-dom';
import MessageService from '../../service/MessageService';
import Clock from '../Clock';
// import { TIMEOUT_IDLE, TIMEOUT_CLOCK, TIMEOUT_DEBOUNCE } from "./config";
import { RoleMap } from '../../utils/roleUtils';
import { BreadcrumbMap } from '../../utils/breadcrumbUtils';
import UpdateService from '../../service/UpdateService';
// import { configMyPouchDb, configPouchDb } from '../../utils/configUtils';

const { TIMEOUT_IDLE } = window;
const { TIMEOUT_CLOCK } = window;
const { TIMEOUT_DEBOUNCE } = window;
const { DO_UPDATER } = window;

function mapPaths(item = '') {
  return BreadcrumbMap[item];
}

export default class AppBreadcrumb extends Component {
  constructor(props) {
    super(props);

    const { userName /* myInstitution, myRole */ } = this.props;
    this.state = {
      timeoutIdle: TIMEOUT_IDLE, // time until user is set to idle, in seconds
      timeoutClock: TIMEOUT_CLOCK, // time for clock & logout, in seconds
      timeoutDebounce: TIMEOUT_DEBOUNCE, // debounce for idletimer, in miliseconds
      runClock: false, // bool to check if clock is already running
      userName,
      /* myInstitution, */ // TODO not necessary anymore?!
      /* myRole, */ // TODO not necessary anymore?!
      crumbs: [],
    };
    this.userPopupText = `${RoleMap[sessionStorage.getItem('role')]
    }<br/>${
      sessionStorage.getItem('institution') !== 'null' ? sessionStorage.getItem('institution') : ''}`;
    this.idleTimer = null;
    this.clock = React.createRef();
    this.onAction = this.onAction.bind(this);
    this.onActive = this.onActive.bind(this);
    this.onIdle = this.onIdle.bind(this);
    this.messageService = new MessageService();
    this.updateService = new UpdateService();
  }

  componentDidMount = async () => {
    // const { ENVIRONMENT } = window;
    // const MY_POUCH_DB = window.MY_CACHE_NAME;
    // const POUCH_DB = window.CACHE_DB;
    // const localDB = new PouchDB(MY_POUCH_DB);
    // const remoteDB = new PouchDB(POUCH_DB);
    /*
    localDB.replicate.from(remoteDB).on('complete', () => {
      // console.log("componentDidMount: done")
    }).on('error', (err) => {
      // eslint-disable-next-line no-console
      console.error('error in componentDidMount:', err);
    });
    */
    const { history } = this.props;
    let paths = history.location.pathname.split('/');
    paths.splice(0, 1);

    if (paths[0]) {
      paths = paths.map(mapPaths);
      this.setState({ crumbs: paths.filter((item) => item !== undefined) });
    }

    this.updateService.updater(DO_UPDATER);
  }

  // triggers if user does any action, stops the clock
  // eslint-disable-next-line no-unused-vars
  onAction(e) {
    const isAction = this.idleTimer || '';
    const clock = this.clock.current || '';
    const { runClock } = this.state;
    if (runClock) {
      if (clock) {
        this.clock.current.stop();
        this.setState({ runClock: false });
      }
    }
    if (isAction) {
      this.idleTimer.reset();
    }
  }

  // triggers if user is active, resets the idle timer
  // eslint-disable-next-line no-unused-vars
  onActive(e) {
    const isActive = this.idleTimer || '';
    if (isActive) {
      this.idleTimer.reset();
    }
  }

  // triggers if user is idle, starts clock
  onIdle() {
    const { runClock } = this.state;
    if (!runClock) {
      this.setState({
        runClock: true,
      });
      if (this.idleTimer.isIdle()) {
        this.clock.current.start();
      }
    }

    // this.idleTimer.stop();
    // TODO why is the logout deactivated here?
    // this.messageService.postUserLogout(sessionStorage.getItem('logoutId'))
  }
  // TODO can this be deleted?
  /* linkClick() {
    window.location.replace('./dashboard');
  } */

  render() {
    // TODO can this be deleted?
    /* #ref20200907
    const { location } = this.props;

    let items = [
      { label: 'Benutzerverwaltung', url: '/useradmin' },
      { label: 'Benutzerdaten/Zugriffsrechte' },
    ];

    const home = { icon: 'pi pi-home', url: '/dashboard' }
    //<BreadCrumb model={this.state.myRole} home={home}/>
    #ref20200907 */
    const {
      timeoutDebounce, timeoutIdle, crumbs, timeoutClock, userName,
    } = this.state;
    const { history } = this.props;
    return (
      <div className="layout-breadcrumb" style={{ paddingTop: '4px' }}>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={timeoutDebounce}
          timeout={1000 * timeoutIdle}
        />
        <ul style={{ marginTop: '2px' }}>
          <li>
            <Link to="/">
              <button type="button" className="p-link" id="backhome">
                <i className="material-icons">
                  home
                </i>
              </button>
            </Link>
          </li>
          {crumbs.length > 0 ? (crumbs.map((item, i) => {
            const key = `crumbLevel_${i}`;
            return (
              <li key={key}>
                <Link to={item.url}>
                  {`> ${item.label}`}
                </Link>
              </li>
            );
          })) : ''}
        </ul>
        <div className="layout-breadcrumb-options">
          <Clock seconds={timeoutClock} ref={this.clock} />
          <Button
            label={userName}
            icon="pi-md-account-circle"
            className="p-button-secondary"
            id="userinfo"
            style={{ marginLeft: 4, width: 'auto', height: 'auto' }}
            onClick={() => history.push('../userdata')}
            tooltip={this.userPopupText}
          />
        </div>
      </div>
    );
  }
}

AppBreadcrumb.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  userName: PropTypes.string.isRequired,
};
